// @ts-nocheck
/* eslint-disable */
export const listIcon = {
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.625 3.75H5.5a2 2 0 00-2 2v15a2 2 0 002 2h13a2 2 0 002-2v-15a2 2 0 00-2-2h-.125M10.5 8.75h7M10.5 12.75h7M10.5 16.75h7M6.25 8.75h1M6.25 12.75h1M6.25 16.75h1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 2.25h2l1.106-.553a2 2 0 011.788 0L14 2.25h2v2H8v-2z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'list' as const,
};
